<template>
  <memlist-card>
    <m-row>
      <m-col lg="6">
        <memlist-checkbox
          v-model="show_history"
          :text="$t('SAMPLE.SHOW_HISTORY')"
        />
      </m-col>
      <m-col lg="6">
        <div class="d-flex justify-end">


          <memlist-icon-button
            class="mr-2 mb-2"
            icon="fa fa-play"
            :text="$t('SAMPLE.START_ALL')"
            variant="success"
            @click="start_all_clicked"
          />

          <memlist-icon-button
            class="mr-2 mb-2"
            icon="fa fa-stop"
            :text="$t('SAMPLE.STOP_ALL')"
            variant="danger"
            @click="stop_all_clicked"
          />

          <memlist-spinner-icon-button
            class="mb-2 mr-4"
            ref="export-button"
            :text="$t('SAMPLE.EXPORT_SUMMARY')" 
            icon="menu-icon flaticon2-file"
            @click="export_summary_excel_clicked"
          />

          <memlist-icon-button
            class="mb-2"
            icon="menu-icon flaticon2-plus"
            :text="$t('SAMPLE.CREATE')"
            variant="primary"
            @click="createStickprovClicked"
          />
        </div>
      </m-col>
    </m-row>
    <memlist-static-table
      id="stickprov-table"
      :fields="headers"
      :items="items"
    >
      <template #cell(stickprov_id)="row">
        <div class="justify-content-end d-flex">
          <div v-if="row.item.is_stopped || !row.item.has_started">
            <a
              class="btn btn-icon btn-light btn-sm mx-3"
              @click.prevent="startEvent(row.item.stickprov_id, true)"
            >
              <span class="svg-icon svg-icon-md svg-icon-primary">
                <!--begin::Svg Icon-->
                <i class="fas fa-play" style="color:#3699FF"></i>
                <!--end::Svg Icon-->
              </span>
            </a>
          </div>
          <div v-else>
            <a
              class="btn btn-icon btn-light btn-sm mx-3"
              @click.prevent="startEvent(row.item.stickprov_id, false)"
            >
              <div class="svg-icon svg-icon-md svg-icon-primary">
                <!--begin::Svg Icon-->
                <i class="fas fa-stop" style="color:#e63113"></i>
                <!--end::Svg Icon-->
              </div>
            </a>
          </div>
          

          <memlist-table-button class="mr-3" @click="selectStickprovClicked(row.item.stickprov_id)" svg="/assets/svg/pencil-square.svg" :tooltip="$t('COMMON.EDIT')"/>
          <memlist-table-button @click="deleteStickprovClicked(row.item.stickprov_id)" svg="/assets/svg/trash2.svg" :tooltip="$t('COMMON.DELETE')"/>

        </div>
      </template>
    </memlist-static-table>
  </memlist-card>
</template>

<script>
import axios from 'axios';
import { toasts } from '@/core/mixins/toastr-helper.mixin.js';
import { get_base_url, downloadWithAxios } from '@/core/services/fileDownload';
import { mapGetters } from 'vuex';

export default {
  name: 'StickprovTable',
  props: ['items', 'currentCompanyId'],
  emits: ['show_history_toggled', 'createStickprovClicked', 'selectStickprovClicked', 'deleteStickprovClicked', 'startEvent'],
  components: {

  },
  mixins: [ toasts ],
  watch: {
    show_history(newcheck, oldcheck) {
      this.$emit('show_history_toggled', newcheck);
    }
  },
  computed: {
    ...mapGetters(['currentCompanyId','currentPeriodId']),
  },
  methods: {
    async start_all_clicked() {
      const loader = this.$loading.show();

      try {
        const res = await axios.post(`/stickprov/start/period/${this.currentPeriodId}`, {});

        if (res.status === 200) {
          this.$emit('all_started', res.data);
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SAMPLE.UNABLE_START') );
        }
      }
      catch (err) {
        console.error('start_all_clicked', err);
      }

      loader && loader.hide();
    },
    async stop_all_clicked() {
      const loader = this.$loading.show();

      try {
        const res = await axios.post(`/stickprov/stop/period/${this.currentPeriodId}`, {});

        if (res.status === 200) {
          this.$emit('all_stopped', res.data);
        }
        else {
          this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SAMPLE.UNABLE_STOP') );
        }
      }
      catch (err) {
        console.error('stop_all_clicked', err);
      }

      loader && loader.hide();
    },

    async export_summary_excel_clicked() {
      const res = await axios.post(`/stickprov/summary/${this.currentPeriodId}/xlsx`, {});
  
      if (res.status === 201) {
        downloadWithAxios(get_base_url() + `/dlfile/${res.data.linkstr}`, res.data.name);
      } else {
        this.toastr('danger', this.$t('COMMON.ERROR'), this.$t('SAMPLE.UNABLE_CREATE_EXCEL') );
      }

      this.$refs['export-button'].stop();
    },
    createStickprovClicked() {
      this.$emit('createStickprovClicked');
    },
    selectStickprovClicked(stickprov_id) {
      this.$emit('selectStickprovClicked', stickprov_id);
    },
    deleteStickprovClicked(stickprov_id) {
      this.$emit('deleteStickprovClicked', stickprov_id);
    },
    startEvent(stickprov_id, status) {
      this.$emit('startEvent', stickprov_id, status);
    },

  },
  data() {
    return {
      show_history: false,
      headers: [
        {
          key: 'company.name',
          label: this.$t('COMPANY.COMPANY'),
          sortable: true,
          thClass: 'td-short5',
          tdClass: 'td-short5',
        },
        {
          key: 'deadline',
          label: this.$t('SAMPLE.DEADLINE'),
          thClass: 'td-short4',
          tdClass: 'td-short4',
          
          sortable: true
        },
        {
          key: 'num_members',
          label: this.$t('SAMPLE.SHORT_NUM_MEMBERS'),
          thClass: 'td-short4',
          tdClass: 'td-short4',
          sortable: true
        },
        {
          key: 'num_answers',
          label: this.$t('SAMPLE.SHORT_NUM_ANSWERS'),
          thClass: 'td-short4',
          tdClass: 'td-short4',
          
        },
        {
          key: 'num_confirm',
          label: '# ' + this.$t('COMMON.YES'),
          thClass: 'td-short4',
          tdClass: 'td-short4',
          
        },
        {
          key: 'num_reject',
          label: '# ' + this.$t('COMMON.NO'),
          thClass: 'td-short4',
          tdClass: 'td-short4',
          
        },
        {
          key: 'stickprov_id',
          label: '',
          thClass: 'w-140px pl-0',
          tdClass: 'w-140px pl-0'
        }
      ],
      list: []
    };
  }
};
</script>
<style scoped>
  @media screen and (max-width: 768px) {
    #show-earlier {
      margin-bottom: 1rem;
    }
  }
</style>
